module.exports = __webpack_public_path__ + "static/img/pic-cnt-4.43f643b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer4/en/pic-cnt-4.png
// module id = 6W3A
// module chunks = 0